import React from 'react'
import {
    BottomNavigation,
    BottomNavigationAction,
    Paper,
    Tooltip,
} from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import Homeimg from '../../assets/images/home_3.svg'
import SolarPlant from '../../assets/images/solar plant_3.svg'
import Settingsicon from '../../assets/images/settings.svg'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import FeedIcon from '@mui/icons-material/FeedOutlined'
import usePermission from '../../hooks/usePermission'

const MobileBottomNav = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { can, is } = usePermission()

    const navItems = [
        {
            label: 'Home',
            value: '/dashboard',
            icon: <img src={Homeimg} alt="home icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
        },
        {
            label: 'Solar Plant List',
            value: '/solarplantlist',
            icon: <img src={SolarPlant} alt="solarplant icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
            permissions: ['entity.all'],
        },
        {
            label: 'Issue Management',
            value: '/issue-management',
            icon: <AssignmentIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['issue.all'],
            hideForRoles: ['Finance'],
        },
        {
            label: 'DGR',
            value: '/daily-generation-report',
            icon: <AnalyticsIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['analytics.all'],
        },
        {
            label: 'Billing Records',
            value: '/billing-records',
            icon: <ReceiptLongIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['invoice.all'],
        },
        {
            label: 'Invoice Records',
            value: '/invoice-records',
            icon: <FeedIcon sx={{ fontSize: 24, opacity: 0.6 }} />,
            permissions: ['invoice.all'],
        },
        {
            label: 'Settings',
            value: '/settings',
            icon: <img src={Settingsicon} alt="Settings icon" style={{ width: 24, height: 24, objectFit: 'contain' }} />,
            permissions: ['organization.all'],
        },
    ]

    const filteredItems = navItems.filter((item) => {
        if (item.hideForRoles && item.hideForRoles.some((role) => is(role))) {
            return false
        }
        if (item.permissions) {
            return is('Super Admin') || is('Admin') || item.permissions.some((p) => can(p))
        }
        return true
    })

    //current active tab based on pathname
    const getCurrentValue = () => {
        const pathname = location.pathname

        //special case for technical and businessview
        if (pathname.includes('/plantTechnicalView') || pathname.includes('/plantBusinessView')) {
            return '/solarplantlist'
        }

        const matchedItem = filteredItems.find((item) =>
            pathname.startsWith(item.value)
        )
        return matchedItem?.value || '/dashboard'
    }

    const currentValue = getCurrentValue()
    //console.log('MobileBottomNav Render:', { currentValue, pathname: location.pathname })

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200, // Reduced from 1400 to appear below modals (1300)
                elevation: 10,
                boxShadow: '0 -2px 10px rgba(0,0,0,0.1)', // Added top shadow
            }}
        >
            <BottomNavigation
                showLabels={false}
                value={currentValue}
                onChange={(event, newValue) => {
                    navigate(newValue)
                }}
                sx={{
                    height: 64,
                    '& .MuiBottomNavigationAction-root': {
                        minWidth: 'auto',
                        flex: '0 0 auto',
                        px: 2,
                        color: '#666',
                        borderTop: '3px solid transparent',
                        transition: 'all 0.3s ease',
                        '&.Mui-selected': {
                            color: '#1976d2',
                            borderTop: '3px solid #1976d2',
                            '& .MuiSvgIcon-root': {
                                color: '#1976d2',
                            },
                            '& img': {
                                filter: 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(1352%) hue-rotate(192deg) brightness(95%) contrast(92%)',
                            },
                        },
                    },
                    display: 'flex',
                    overflowX: 'auto',
                    justifyContent: 'flex-start',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                {filteredItems.map((item) => {
                    const isActive = currentValue === item.value
                    return (
                        <Tooltip title={item.label} key={item.value} arrow>
                            <BottomNavigationAction
                                label={item.label}
                                value={item.value}
                                icon={item.icon}
                                sx={{
                                    minWidth: 'auto',
                                    flex: '0 0 auto',
                                    px: 2,
                                    color: isActive ? '#1976d2 !important' : '#666',
                                    borderTop: isActive ? '3px solid #1976d2' : '3px solid transparent',
                                    transition: 'all 0.3s ease',
                                    '&.Mui-selected': {
                                        color: '#1976d2',
                                        borderTop: '3px solid #1976d2',
                                    },
                                    '& .MuiSvgIcon-root': {
                                        color: isActive ? '#1976d2 !important' : 'inherit',
                                    },
                                    '& img': {
                                        filter: isActive
                                            ? 'brightness(0) saturate(100%) invert(37%) sepia(93%) saturate(1352%) hue-rotate(192deg) brightness(95%) contrast(92%)'
                                            : 'grayscale(1) brightness(0.8) opacity(0.6)',
                                    },
                                }}
                            />
                        </Tooltip>
                    )
                })}
            </BottomNavigation>
        </Paper>
    )
}

export default MobileBottomNav
